<template>
    <div class="w-full h-full flex justify-center items-center">
        <div class="bg-[#F6FAFE] custom-font mb-[30px] py-10 px-14 w-[90%] max-w-[1250px] h-[650px] rounded-3xl">
            <div class="flex h-[40px] justify-between items-center">
                <div class="text-4xl">
                    {{ locState.userRequestBody.fio }}
                </div>
                <div class="flex justify-between items-center cursor-pointer">
                    <ai-refresh-in-white-circle @click="updateData" />
                </div>
            </div>

            <div class="mt-3 flex justify-between">
                <div class="bg-white py-4 px-8 w-[49%] rounded-2xl">
                    <div class="font-medium text-xl">Параметры аккаунта:</div>
                    <div class="mt-1">Авторизация: {{ authorizationType }}</div>
                    <div class="mt-4 h-[180px] flex flex-col justify-between">
                        <dx-text-box
                            class="custom-textbox"
                            label-mode="outside"
                            label="Логин:"
                            :read-only="true"
                            :value="locState.userRequestBody.user_login"
                        />
                        <dx-text-box
                            class="custom-textbox"
                            label-mode="outside"
                            label="Электронная почта:"
                            :read-only="true"
                            :value="locState.userRequestBody.e_mail"
                        />
                        <div class="flex justify-between items-end">
                            <dx-date-box
                                class="custom-textbox"
                                width="49%"
                                label-mode="outside"
                                label="Срок действия пароля:"
                                type="datetime"
                                :read-only="true"
                                :value="locState.userRequestBody.expired_at"
                            />
                            <ai-button
                                width="49%"
                                height="33px"
                                class="rounded-md"
                                text="Сменить пароль"
                                @click="userChangePasswordForm"
                            />
                            <user-change-password-popup />
                        </div>
                    </div>
                </div>
                <div class="bg-white py-4 px-8 w-[49%] h-[350px] rounded-2xl">
                    <div class="font-medium text-xl">Параметры сотрудника:</div>
                    <div class="mt-4 h-[80%] flex flex-col justify-between">
                        <dx-text-box
                            class="custom-textbox"
                            label-mode="outside"
                            label="ФИО:"
                            :read-only="true"
                            :value="locState.userRequestBody.fio"
                        />
                        <dx-text-box
                            class="custom-textbox"
                            label-mode="outside"
                            label="Должность:"
                            :read-only="true"
                            :value="locState.userRequestBody.namedolzh"
                        />
                        <dx-text-box
                            class="custom-textbox"
                            label-mode="outside"
                            label="Подразделение:"
                            :read-only="true"
                            :value="locState.userRequestBody.department"
                        />
                        <div class="flex justify-between items-end">
                            <dx-text-box
                                class="custom-textbox"
                                width="49%"
                                label-mode="outside"
                                label="Мобильный телефон:"
                                :read-only="true"
                                :value="locState.userRequestBody.mobile_phone"
                            />
                            <dx-text-box
                                class="custom-textbox"
                                width="49%"
                                label-mode="outside"
                                label="Рабочий телефон:"
                                :read-only="true"
                                :value="locState.userRequestBody.phone"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-white mt-[19px] py-4 px-8 rounded-2xl">
                <div class="w-[70%] flex justify-between">
                    <div class="font-medium text-xl">Настройка оповещений:</div>
                    <dx-check-box
                        v-model:value="locState.userRequestBody.notification_email"
                        text="Отправить на электронную почту"
                        :disabled="true"
                        @valueChanged="changedEmailOrPush"
                    />
                    <dx-check-box
                        v-model:value="locState.userRequestBody.notification_push"
                        text="Отправлять Push-соообщения"
                        :disabled="true"
                        @valueChanged="changedEmailOrPush"
                    />
                </div>
                <div class="mt-2 flex justify-between items-end">
                    <dx-text-box
                        class="custom-textbox"
                        v-model:value="locState.userRequestBody.notification_days"
                        :disabled="true"
                        width="32%"
                        label-mode="outside"
                        label="Количество дней до срока исполнения:"
                        :is-valid="isValidDays"
                        :validation-error="{ message: 'Это поле обязательно' }"
                        :read-only="!isEmailOrPush"
                        value-change-event="input keyup change paste"
                        mask-invalid-message="Допускаются только цифры"
                    />
                    <dx-date-box
                        class="custom-textbox"
                        v-model:value="locState.userRequestBody.notification_time"
                        :disabled="true"
                        type="time"
                        :open-on-field-click="true"
                        date-serialization-format="HH:mm:ss"
                        :useMaskBehavior="true"
                        :showClearButton="true"
                        width="32%"
                        label-mode="outside"
                        label="Время напоминаний:"
                        :is-valid="isValidTime"
                        :validation-error="{ message: 'Это поле обязательно' }"
                        :read-only="!isEmailOrPush"
                    />
                    <ai-button
                        width="32%"
                        height="33px"
                        class="rounded-md"
                        text="Сохранить"
                        :disabled="disableSaveButton || true"
                        @click="updateUser"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { DxTextBox, DxDateBox, DxCheckBox } from 'devextreme-vue';
import UserChangePasswordPopup from '@/views/administration/users/user-change-password-popup.vue';
import AiButton from '@/components/ai-button/ai-button.vue';
import usersLocalStore from '@/views/administration/users/store.js';
import enviromentStore from '@/store/enviroment-data.js';
import { updateUserData } from '@/service/admin-service.js';
import { dxUiNotify } from '@/utils/dx-helper.js';
import { hideLoadPanel, showLoadPanel } from '@/components/utils/ai-global-load-panel.js';

const { state: locState, setUserRequestBody } = usersLocalStore;
const { state: envState, getUserData, getOfficialUserData } = enviromentStore;


const isEmailOrPush = computed(() => locState.userRequestBody.notification_email || locState.userRequestBody.notification_push);
const authorizationType = computed(() => (locState.userRequestBody.from_ad ? 'AD' : 'Логин'));
const isValidDays = computed(() => isEmailOrPush.value ? !!locState.userRequestBody.notification_days : true);
const isValidTime = computed(() => isEmailOrPush.value ? !!locState.userRequestBody.notification_time : true);
const disableSaveButton = computed(() => dataNotChanged.value);

const dataNotChanged = ref(true);

onMounted(async () => {
    await updateData(false);
});

const startWatching = () => {
    locState.userRequestBody.notification_days = locState.userRequestBody.notification_days ?? '';
    const originalValues = {
        notification_push: locState.userRequestBody.notification_push,
        notification_email: locState.userRequestBody.notification_email,
        notification_days: locState.userRequestBody.notification_days,
        notification_time: locState.userRequestBody.notification_time,
    };

    dataNotChanged.value = true;
    locState.stopWatching = watch(
        () => [
            locState.userRequestBody.notification_push,
            locState.userRequestBody.notification_email,
            locState.userRequestBody.notification_days,
            locState.userRequestBody.notification_time,
        ],
        ([push, email, days, time]) => {

            const valuesChanged =
                push !== originalValues.notification_push ||
                email !== originalValues.notification_email ||
                days !== originalValues.notification_days ||
                time !== originalValues.notification_time;
            const validationFailed =
                (push || email) && (!days || !time);

            dataNotChanged.value = !valuesChanged || validationFailed;
        },
        { deep: false },
    );
};

const updateData = async (showNotify = true) => {
    if (locState.stopWatching) await locState.stopWatching();
    showLoadPanel();
    await getUserData();
    await getOfficialUserData();

    const user = {
        ...envState.officialData,
        ...envState.userData,
        id: envState.userData.id,
    };

    setUserRequestBody({ ...user });
    hideLoadPanel();
    if (showNotify) dxUiNotify('Данные успешно обновлены', 'success');
    startWatching();
};

const changedEmailOrPush = () => {
    if (!isEmailOrPush.value) {
        locState.userRequestBody.notification_days = null;
        locState.userRequestBody.notification_time = null;
    }
};

const userChangePasswordForm = () => {
    locState.userChangePasswordPopupVisible = true;
};

const updateUser = async () => {
    locState.stopWatching();
    const result = await updateUserData(locState.userRequestBody);
    if (result.success) {
        dxUiNotify('Данные успешно обновлены', 'success');
        locState.userCardViewPopupVisible = false;
        await updateData();
    } else {
        dxUiNotify('Ошибка при сохранении данных', 'error');
    }
};
</script>

<style scoped>
.custom-font {
    font-family: Golos, GolosText, sans-serif;
}

.custom-textbox {
    border-radius: 5px;
    color: black;
}
</style>
